import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Paragraph } from '@scentregroup/ui'
import Article from '../article'
import ResponsiveImage from '../responsive-image'
import Trackable from '../trackable'
import { trackingActions, trackingTypes } from '../../constants'
import style from './index.module.scss'
import { occurrencesType, imageType } from './../../types'
const WhatsHappeningListItem = ({
  link,
  image,
  category,
  heading,
  location,
  body,
  occurrences,
  analyticsMetadata,
}) => (
  <Trackable
    {...analyticsMetadata}
    trackingAction={trackingActions.viewPromotion}
    type={trackingTypes.promotion}
  >
    <div className={style.listItem}>
      <div className={style.imageWrapper}>
        <Link to={link}>
          <ResponsiveImage
            desktopImageUrl={image.src}
            mobileImageUrl={image.src}
            mobileRatio="square"
            desktopRatio="square"
            numberOfItems={3}
            alt={image.alt}
          />
        </Link>
      </div>
      <Article
        className={style.article}
        superheading={category}
        heading={heading}
        location={location}
        link={link}
        occurrences={occurrences}
      >
        <Paragraph type="medium" className={style.summary}>
          {body}
        </Paragraph>
      </Article>
    </div>
  </Trackable>
)
WhatsHappeningListItem.propTypes = {
  link: PropTypes.string.isRequired,
  image: imageType.isRequired,
  category: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  location: PropTypes.string,
  body: PropTypes.string.isRequired,
  occurrences: occurrencesType,
  analyticsMetadata: PropTypes.shape({
    correlationId: PropTypes.string,
    title: PropTypes.string,
    promotion: PropTypes.shape({
      creative: PropTypes.string,
    }),
  }),
}

export default WhatsHappeningListItem
